import { setMaxSpeedLo } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import NumberFilter from './NumberFilter';
import { useAppSelector } from '@customer/store/hooks';
import { MeasurementUnit } from '@customer/store/apis/authApi';

export const MaxSpeedLoFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicInputElement>) => {
  const { t } = useTranslation();
  const units = useAppSelector(state => state.auth.units);

  return (
    <NumberFilter
      filterName="maxSpeedLo"
      label={
        label ??
        t('maxObjectSpeed', {
          obj: t('LO'),
          unit: t(units === MeasurementUnit.Metric ? 'unit.kmph' : 'unit.mph'),
        })
      }
      elementRef={elementRef}
      action={setMaxSpeedLo}
      placeholder={t(units === MeasurementUnit.Metric ? 'speed.kmph' : 'speed.mph', { speed: 0 })}
    />
  );
};

export default MaxSpeedLoFilter;
